import { useState, useCallback, useEffect, useMemo } from "react";
import axios from "axios";
import { GetToken, isExpiredToken, setToken, logout } from "./auth.js";
import { exibirErroTratado } from "../utilities/global.js";
import { useDispatch } from "react-redux";
// Pode ser algum servidor executando localmente:
// http://localhost:3000

export const useAxiosLoader = () => {
  const Axios = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  const dispatch = useDispatch();

  const inc = () => {
    dispatch({ type: "counterRequest/increment" });
  };
  const dec = () => {
    dispatch({ type: "counterRequest/decrement" });
  };

  const interceptors = {
    request: (config) => {
      const tokenStr = GetToken();

      if (tokenStr != null) {
        let token = JSON.parse(tokenStr);
        let dataToken = token.token;

        if (config.data && typeof config.data === "object" && config.data.get("grant_type") === "refresh_token") {
          return inc(), config;
        }

        config.headers.Authorization = `${dataToken.token_type}  ${dataToken.access_token}`;
        config.headers["Content-Type"] = "application/json";
      }
      config.headers["Content-Type"] = "application/json";
      return inc(), config;
    },

    errorRequest: (error) => (dec(), Promise.reject(error)),

    response: (response) => (dec(), response),

    errorResponse: (error) => {
      const originalRequest = error.config;

      if (!error.response) {
        return dec(), Promise.reject(error);
      }

      if (
        error.response.status === 401 &&
        originalRequest.url === `/oauth/token` &&
        originalRequest.data === "grant_type=refresh_token"
      ) {
        window.$toast.current.show({
          severity: "error",
          summary: "Sua sessão expirou! Por favor Logue novamente",
          life: 3000,
        });
        logout();
        dispatch({ type: "SETUSER", value: null });
        return dec(), Promise.reject(error);
      }

      if (error.response.status === 401 && isExpiredToken() && !originalRequest._retry) {
        originalRequest._retry = true;
        let formData = new URLSearchParams();
        formData.append("grant_type", "refresh_token");

        delete window.$http.defaults.headers.common["Content-Type"];
        window.$http.defaults.headers.common["Authorization"] = `Basic ${btoa(
          process.env.REACT_APP_USERNAME_API + ":" + process.env.REACT_APP_PASSWORD_API
        )}`;

        return (
          dec(),
          window.$http
            .post(`/oauth/token`, formData, {
              withCredentials: true,
              headers: { "Content-Type": "application/x-www-form-urlencoded; charset=utf-8" },
            })
            .then((res) => {
              if (res.status === 200) {
                let userlogado = JSON.parse(GetToken());
                userlogado.token = res.data;

                logout();
                setToken(JSON.stringify(userlogado));

                originalRequest.headers.Authorization = `${userlogado.token.token_type}  ${userlogado.token.access_token}`;
                originalRequest.headers["Content-Type"] = "application/json";

                return window.$http(originalRequest);
              }
            })
            .catch(() => Promise.reject(error))
        );
      }

      if (error.response) {
        exibirErroTratado(error, "error", null);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        exibirErroTratado(error, "error", null);
      } else {
        // Something happened in setting up the request that triggered an Error
      }

      // Retorna a promisse rejeitada
      return dec(), Promise.reject(error);
    },
  };

  Axios.interceptors.request.use(interceptors.request, interceptors.errorRequest);
  Axios.interceptors.response.use(interceptors.response, interceptors.errorResponse);

  return Axios;
};

export default useAxiosLoader;
